import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Globe, MapPin } from 'lucide-react';

const LOGO_URL = "/logo.png";

const services = [
  "Custom Home Build", "Commercial Finishing", "Condominium Finishing",
  "Plaster Moulding & Fireplace Mantle", "Residential Renovation", "Home Additions",
  "Kitchen Cabinets & Refinishing", "Painting & Decoration",
  "Flooring & Tiling", "Restoration", "Millwork",
];

const Footer = () => (
  <footer className="bg-slate-950 text-slate-400" data-testid="footer">
    {/* CTA Banner */}
    <div className="border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 flex flex-col md:flex-row items-center justify-between gap-6">
        <h2 className="text-3xl md:text-4xl font-black text-white tracking-tight text-center md:text-left">
          READY TO START YOUR PROJECT?
        </h2>
        <Link
          to="/contact"
          data-testid="footer-cta-btn"
          className="shrink-0 bg-[#00A2E8] hover:bg-[#0088C4] text-white px-8 py-4 font-bold text-sm tracking-widest transition-colors duration-200"
        >
          GET A FREE QUOTE
        </Link>
      </div>
    </div>

    {/* Main Footer */}
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        {/* Brand */}
        <div className="md:col-span-3">
          <img
            src={LOGO_URL}
            alt="Ariana General Contracting"
            className="h-20 w-auto mb-5 object-contain"
          />
          <p className="text-sm leading-relaxed">
          <p className="text-sm leading-relaxed">
              Ontario's trusted partner for residential and commercial projects. Quality craftsmanship on every project.
            </p>
          </p>
          <div className="mt-5 flex flex-col gap-3 text-sm">
            <a href="tel:+14165703834" data-testid="footer-phone" className="flex items-center gap-2 hover:text-[#00A2E8] transition-colors">
              <Phone className="w-4 h-4 text-[#00A2E8] shrink-0" strokeWidth={1.5} />
              +1 416 570 3834
            </a>
            <a href="mailto:Jay@ArianaBuild.ca" data-testid="footer-email" className="flex items-center gap-2 hover:text-[#00A2E8] transition-colors">
              <Mail className="w-4 h-4 text-[#00A2E8] shrink-0" strokeWidth={1.5} />
              Jay@ArianaBuild.ca
            </a>
            <a href="https://www.ArianaBuild.ca" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#00A2E8] transition-colors">
              <Globe className="w-4 h-4 text-[#00A2E8] shrink-0" strokeWidth={1.5} />
              www.ArianaBuild.ca
            </a>
            <span className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#00A2E8] shrink-0" strokeWidth={1.5} />
              Ontario
            </span>
          </div>
        </div>

        {/* Services */}
        <div className="md:col-span-6">
          <h4 className="text-white font-bold text-xs tracking-[0.2em] uppercase mb-5">Our Services</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {services.map(s => (
              <Link key={s} to="/services" className="text-sm hover:text-[#00A2E8] transition-colors duration-200 py-1 border-b border-slate-800/50">
                {s}
              </Link>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="md:col-span-3">
          <h4 className="text-white font-bold text-xs tracking-[0.2em] uppercase mb-5">Quick Links</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'Home', path: '/' }, { name: 'About Us', path: '/about' },
              { name: 'Services', path: '/services' }, { name: 'Portfolio', path: '/portfolio' },
              { name: 'Contact', path: '/contact' },
            ].map(link => (
              <Link key={link.path} to={link.path} className="text-sm hover:text-[#00A2E8] transition-colors duration-200 py-1 border-b border-slate-800/50">
                {link.name}
              </Link>
            ))}
          </div>
          <div className="mt-6">
            <h4 className="text-white font-bold text-xs tracking-[0.2em] uppercase mb-3">Contact</h4>
            <p className="text-sm font-semibold text-slate-300">Jay Wahid</p>
            <p className="text-xs text-slate-500 mt-1">Licensed General Contractor<br />Ontario</p>
            {/* Proudly Canadian Badge — transparent PNG */}
            <div className="mt-3">
              <img
                src="/canadian-badge.png"
                alt="Proudly 100% Canadian Owned and Operated"
                style={{ width: '185px', display: 'block' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Copyright */}
    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-600">
        <p>© {new Date().getFullYear()} Ariana General Contracting. All rights reserved.</p>
        <p>Ontario's Premier General Contractor</p>
      </div>
    </div>
  </footer>
);

export default Footer;
